<template>
		<span>
			<a rel="nofollow" href="javascript:void(0)" @click="openModal" :class="{ 'uk-navbar-item uk-padding-small' : navBarItem }">
				<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg> 
				<span :class="{ 'uk-visible@s' : !text }">{{ text }}</span>
			</a>
			<div id="search-modal" class="uk-flex-top" uk-modal>
				<div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical">
					<button class="uk-modal-close-default" type="button" uk-close></button>
					<h4 class="uk-modal-title">
						<span class="material-symbols-outlined large"><svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg></span> 
						<span class="uk-visible@s">{{ text }}</span>
					</h4>
					<form :action="action" ref="searchForm">
						<input v-model="searchTerm" name="q" ref="searchInput" class="uk-input" type="text" placeholder="Vul een zoekterm in..." required>
						<button class="uk-button uk-button-primary uk-margin-top">Go!</button>
					</form>
				</div>
			</div>
	</span>
</template>

<script>
import { ref, onMounted, nextTick } from 'vue';

export default {
	name: 'SearchModal',

	props: {
		action: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: false,
			default: "Zoeken"
		},
		navBarItem: {
			type: Boolean,
			required: false,
			default: false
		}		
	},

	setup() {
		const searchTerm = ref('');
		const searchInput = ref(null);
		const searchForm = ref(null);

		const openModal = () => {
			UIkit.modal('#search-modal').show();
			nextTick(() => {
				setTimeout(function() {
					searchInput.value.focus();
				},300);
			});
		};

		const search = () => {
			UIkit.modal('#search-modal').hide();
		};

		return {
			searchTerm,
			search,
			openModal,
			searchInput
		};
	},
};
</script>

<style scoped>
/* Add any required CSS here */
</style>
